import { render, staticRenderFns } from "./StationsCreateEdit.vue?vue&type=template&id=78523500"
import script from "./StationsCreateEdit.vue?vue&type=script&lang=js"
export * from "./StationsCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports